"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var componentBuilder_1 = require("./componentBuilder");
var factory_1 = require("./factory");
var internal_1 = require("../types/internal");
var placeholder_1 = require("./placeholder");
var ComponentLocalizer = (function () {
    function ComponentLocalizer() {
        var _this = this;
        this.get = function (text, params) {
            var translatedText = internal_1.internalStringLoader.getString(text);
            if (!params) {
                return translatedText;
            }
            // Fabric automation encourages to surround placeholders with {Locked="{PLACEHOLDER}"} to block translators
            // from removing spective part in translated string. Strip it, if present.
            translatedText = translatedText.replace(/{Locked="([^"]+)"}/g, '$1');
            var strings = factory_1.getStringDictionary(params);
            var replacedStrings = internal_1.internalStringReplacer.getString(translatedText, strings);
            var dictionary = factory_1.getLocalizationDictionary(text, params, placeholder_1.placeHolder.split(replacedStrings));
            if (!dictionary.jsxElements.length && !dictionary.localizableElements.length && !dictionary.domElements.length) {
                return replacedStrings;
            }
            return _this.getComponents(dictionary);
        };
    }
    ComponentLocalizer.prototype.init = function (settings) {
        this.navigationAction = settings.navigationAction;
    };
    ComponentLocalizer.prototype.getComponents = function (params) {
        return componentBuilder_1.buildComponents(params.knownPlaceholders, params, this.navigationAction);
    };
    return ComponentLocalizer;
}());
exports.ComponentLocalizer = ComponentLocalizer;
exports.componentLocalizer = new ComponentLocalizer();
